import { Route, Routes } from "react-router-dom";
import { DeepResearchTab } from "./DeepResearchTab.js";

/** FIX-062: `/generate/create/deep-research/*` - a fifth, isolated Create path; VIDEO, IMAGE, REEL and RE are untouched. */
export function DeepResearchRoutes({ tenantId }: { readonly tenantId: string }) {
  return (
    <Routes>
      <Route index element={<DeepResearchTab tenantId={tenantId} />} />
    </Routes>
  );
}
